import React, { useState, useEffect } from "react";
import { Button, TextInput, FileInput, Label } from "flowbite-react";
import { useLocation } from "react-router-dom";

const CreatePopup = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const cliente_id = params.get("cliente_id");

  const [name, setName] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [message, setMessage] = useState("");
  const [popups, setPopups] = useState([]); // ✅ Ahora manejamos una lista de popups
  const [error, setError] = useState("");

  // ✅ Cargar los popups al inicio
  useEffect(() => {
    if (!cliente_id) {
      setError("Error: cliente_id no definido.");
      return;
    }

    fetchPopups();
  }, [cliente_id]);

  const fetchPopups = async () => {
    try {
      const timestamp = new Date().getTime();
      const response = await fetch(`/api/popups?cliente_id=${cliente_id}&v=${timestamp}`);
      if (!response.ok) throw new Error(`Error al obtener los popups: ${response.status}`);

      const data = await response.json();
      if (Array.isArray(data)) {
        setPopups(data); // ✅ Guardar todos los popups en un array
      } else {
        setPopups(data ? [data] : []); // ✅ Si solo hay un popup, lo convertimos en array
      }
    } catch (error) {
      console.error("Error al obtener los popups:", error);
      setError("No se pudieron cargar los popups.");
    }
  };

  // ✅ Manejar cambios en el archivo
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    setFile(selectedFile);
    setPreview(URL.createObjectURL(selectedFile));
  };

  // ✅ Manejar envío del formulario
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!cliente_id) {
      setMessage("Error: cliente_id no definido.");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("file", file);
    formData.append("cliente_id", cliente_id);

    try {
      const response = await fetch("/api/popups", {
        method: "POST",
        body: formData,
      });
      if (!response.ok) throw new Error("Error al subir el popup");

      setMessage("Popup creado exitosamente.");
      setFile(null);
      setPreview(null);
      setName("");

      fetchPopups(); // ✅ Recargar los popups después de crear uno nuevo
    } catch (error) {
      console.error("Error:", error);
      setMessage("No se pudo crear el popup.");
    }
  };

  // ✅ Manejar eliminación de un popup específico
  const handleDeletePopup = async (id) => {
    try {
      const response = await fetch(`/api/popups/${id}`, {
        method: "DELETE",
      });
      if (!response.ok) throw new Error("Error al eliminar el popup.");

      setMessage("Popup eliminado correctamente.");
      fetchPopups(); // ✅ Recargar la lista después de eliminar
    } catch (error) {
      console.error(error);
      setMessage("No se pudo eliminar el popup.");
    }
  };

  return (
    <div className="max-w-lg mx-auto p-4 bg-gray-50 rounded-lg shadow-md">
      <h2 className="text-xl font-semibold text-center mb-4">Gestionar Popups</h2>

      {message && <div className="mb-4 text-green-600 font-medium text-center">{message}</div>}

{/* ✅ Mostrar TODOS los popups con opción de eliminar */}
{popups.length > 0 ? (
  popups.map((popup) => (
    popup.id ? ( // ✅ Verifica que el popup tenga ID (evita que se oculte accidentalmente)
      <div key={popup.id} className="p-4 border rounded-lg bg-white shadow text-center mb-4">
        <h3 className="text-md font-semibold">Popup Activo</h3>
        <p className="text-gray-700 mb-2"><strong>Nombre:</strong> {popup.name}</p>

        {/* ✅ Mostrar un mensaje si `fileUrl` no está disponible */}
        {popup.fileUrl ? (
          popup.fileType && popup.fileType.startsWith("image") ? (
            <img src={popup.fileUrl} alt="Popup" className="w-full h-auto rounded-md shadow-md" />
          ) : popup.fileType && popup.fileType.startsWith("video") ? (
            <video src={popup.fileUrl} controls className="w-full h-auto rounded-md shadow-md"></video>
          ) : (
            <p className="text-gray-600">Formato no soportado.</p>
          )
        ) : (
          <p className="text-gray-500">Archivo no disponible.</p> // ✅ Ya no oculta el popup
        )}

        {/* ✅ Botón de eliminar SIEMPRE visible */}
        <Button color="red" onClick={() => handleDeletePopup(popup.id)} className="mt-4 w-full text-white">
          Eliminar Popup
        </Button>
      </div>
    ) : null
  ))
) : (
  <p className="text-center text-gray-600">No hay popups activos.</p>
)}


      {/* ✅ Formulario para crear un nuevo popup */}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <Label htmlFor="name" value="Nombre del Popup" />
          <TextInput
            id="name"
            type="text"
            placeholder="Nombre del popup"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div>
          <Label htmlFor="file" value="Subir Archivo (imagen, GIF, video)" />
          <FileInput id="file" accept="image/*,video/*" onChange={handleFileChange} required />
        </div>

        {preview && (
          <div className="text-center">
            <h4 className="text-sm font-medium mb-2">Vista Previa:</h4>
            {file?.type?.startsWith("image") ? (
              <img src={preview} alt="Vista previa" className="w-full h-auto rounded-md shadow-md" />
            ) : (
              <video src={preview} controls className="w-full h-auto rounded-md shadow-md"></video>
            )}
          </div>
        )}

        <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white">
          Crear Popup
        </Button>
      </form>
    </div>
  );
};

export default CreatePopup;
